module.exports = __webpack_public_path__ + "img/slide_002_g2.c9aee63e.jpg";